import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=bb1f6d62&"
import script from "./FavoriteButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports